var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99998 1.1C3.95063 1.1 3.09998 1.95066 3.09998 3V21C3.09998 22.0494 3.95064 22.9 4.99998 22.9H19C20.0493 22.9 20.9 22.0494 20.9 21V6.1H20.895L20.8955 6.09951L15.9 1.10089V1.1H4.99998ZM15.9 3.64726V6.1H18.3512L15.9 3.64726Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesSolid);
export default __webpack_public_path__ + "static/media/notes-solid.ebc5e929f3d0b092fcb737ea2eaf5e3e.svg";
export { ForwardRef as ReactComponent };